import cn from 'clsx'
import ResponsiveImage from 'components/Common/ResponsiveImage'
import { transparentize } from 'polished'
import React from 'react'
import styled from 'styled-components'
import { BestOfPrimaryColour } from './BestOfConstants'

const BestOfImage = styled(ResponsiveImage)`
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
  }

  &.overlay-default::after {
    background: ${transparentize(0.5, BestOfPrimaryColour)} linear-gradient(180deg, rgba(0, 127, 134, 0.00) 0%, rgba(16, 136, 143, 0.30) 45%, rgba(9, 75, 78, 0.60) 100%)
  }

  &.overlay-search::after {
    background: ${transparentize(0.5, BestOfPrimaryColour)} linear-gradient(270deg, rgba(0, 127, 134, 0.00) 0%, rgba(16, 136, 143, 0.30) 45%, rgba(9, 75, 78, 0.60) 100%);
  }

  &.overlay-hero::after {
    background: ${transparentize(0.5, BestOfPrimaryColour)} linear-gradient(180deg, rgba(16, 136, 143, 0.20) 0%, rgba(9, 75, 78, 0.90) 29.39%, #043032 55.28%, #043032 60.76%);
  }
`

interface Props extends Omit<React.ComponentProps<typeof ResponsiveImage>, 'id' | 'fit'> {
  overlayStyle: 'default' |'hero' | 'search'
}

function BestOfBackgroundImage(props: Props) {
  const { className, overlayStyle, ...imageProps } = props
  return <BestOfImage
    {...imageProps}
    className={cn(className, `overlay-${overlayStyle}`)}
    id="ac4k6xwtvbfa9yy3k4e4"
    fit="center"
  />
}

export default BestOfBackgroundImage
